/* Speakable structured data for Google Assistant and AI crawlers */

const getSpeakableSchema = (title, description, locale, seller) => {
  if (seller) return;
  if (!title || !description || !locale) return;

  const localeMap = {
    'nl-NL': 'Via Marktplaats',
    'nl-BE': 'Via 2dehands',
    'fr-BE': 'Via 2ememain',
  };
  const localeText = localeMap[locale] || '';
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    speakable: {
      '@type': 'SpeakableSpecification',
      cssSelector: ['.speakable-content-hidden .title', '.speakable-content-hidden .description'],
    },
    name: title,
    description: `${localeText}: ${description}`,
  };
};

export default getSpeakableSchema;
